import { render, staticRenderFns } from "./CharacterCard.vue?vue&type=template&id=20fafbac&scoped=true&"
import script from "./CharacterCard.vue?vue&type=script&lang=js&"
export * from "./CharacterCard.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCard.vue?vue&type=style&index=0&id=20fafbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fafbac",
  null
  
)

export default component.exports